<!--This Component is for the syncing status on Header Nav in Home dashboard with CloudSync-->
<template>
	<div
		@click="syncStore.beginSync({ verify: true })"
		class="flex cursor-pointer flex-row items-center"
	>
		<SyncIconAndText
			:syncState="currentState"
			:updatedDate="updatedDate"
			:pendingPlansCount="pendingPlansCount"
			:percentComplete="syncStore.percentComplete"
		/>
	</div>
</template>

<script setup lang="ts">
import SyncIconAndText from '@/components/common/SyncIconAndText.vue'
import { useCloudSyncService } from '@/services/CloudSync/cloudSyncService'
import { useCrmStore } from '@/stores/crm'
import { useSyncStore } from '@/stores/sync'
import { computedAsync } from '@vueuse/core'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { d } = useI18n()

const syncStore = useSyncStore()
const crmStore = useCrmStore()
const cloudSyncService = useCloudSyncService()

const offline = computed(() => syncStore.offline)

const syncInProgress = computed(() => {
	return syncStore.syncing
})

/**
 * We may want to include debounces in this count as well if there are ever any
 * issues with the speed they are flushed (it should be immediate right now)
 */
const pendingPlansCount = computedAsync(async () => {
	const uniquePendingIds =
		await cloudSyncService.getRelatedPlanIdsForPendingUpserts()
	return uniquePendingIds.length
})

const hasPendingSyncs = computed(() => {
	return cloudSyncService.pendingRequests > 0
})

const currentState = computed(() => {
	if (syncInProgress.value) {
		return 'OnlineSyncing'
	}

	if (offline.value) {
		return hasPendingSyncs.value ? 'OfflinePendingSync' : 'OfflineNoSync'
	}

	return hasPendingSyncs.value ? 'OnlinePendingSync' : 'OnlineNoSync'
})

/** Last updated date */
const updatedDate = computed(() => {
	if (!crmStore.appointments?.downloadedAt) return ''
	let now = new Date()
	let date = new Date(crmStore.appointments?.downloadedAt)
	if (date.toDateString() === now.toDateString()) {
		return d(date, 'time')
	} else {
		return d(date, 'shortDate')
	}
})
</script>

<style scoped></style>
